import React from 'react';
import { Tags } from '@leapfinance/geebee-component-library';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { getVasStatusTagsStyling } from './helpers';
var StatusPillWithInfo = function (_a) {
    var status = _a.status, statusText = _a.statusText, infoText = _a.infoText;
    return (React.createElement(Tags, { title: statusText, endIcon: infoText ? (React.createElement(Tooltip, { title: infoText, arrow: true },
            React.createElement(InfoOutlined, { className: "lfc-text-base" }))) : null, variant: getVasStatusTagsStyling(status), hasActiveBorder: true, containerClasses: "lfc-w-fit", size: "medium" }));
    // return (
    //   <div
    //     className={`${getVasStatusTagsStyling(status).containerClass} lfc-flex lfc-items-center lfc-gap-x-1 lfc-w-fit`}
    //   >
    //     <Tags title={statusText} variant />
    //     <p className={`lfc-font-normal lfc-text-sm lfc-leading-4 ${getVasStatusTagsStyling(status).textClass}`}>
    //       {statusText}
    //     </p>
    //     {infoText ? (
    //       <Tooltip title={infoText} arrow>
    //         <InfoOutlined
    //           fontSize="medium"
    //           className={`lfc-ml-1 lfc-h-4 lfc-w-4 ${getVasStatusTagsStyling(status).textClass}`}
    //         />
    //       </Tooltip>
    //     ) : null}
    //   </div>
    // );
};
export default StatusPillWithInfo;
//# sourceMappingURL=StatusPillWithInfo.js.map